import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2622902a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "card-header"
};
const _hoisted_2 = {
  class: "module-title"
};
const _hoisted_3 = {
  class: "card-body"
};
const _hoisted_4 = {
  class: "module-info"
};
const _hoisted_5 = {
  class: "module-info"
};
const _hoisted_6 = {
  class: "module-info"
};
import { ref } from 'vue';
import { ElRow, ElCol, ElCard } from 'element-plus';
const __default__ = {
  name: 'cloudModel'
};
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {
    // ...（上方引入代码）...
    const modules = ref([{
      title: 'PC云桌面2',
      moduleId: '15501',
      moduleType: '通用',
      openTime: '2022-08-17',
      icon: '' // 无图标时留空，用默认图标替代
    }, {
      title: '团队云桌面',
      moduleId: '16390',
      moduleType: '智屏系统',
      openTime: '2025-07-23',
      icon: ''
    }, {
      title: '华夏之光阅享平台',
      moduleId: '16391',
      moduleType: '智屏系统',
      openTime: '2025-07-23',
      icon: 'https://example.com/red-icon.png' // 自定义图标地址（如红色logo）
    }, {
      title: '容器式-富文本SP',
      moduleId: '16392',
      moduleType: '通用',
      openTime: '2025-09-01',
      icon: ''
    }]);
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_unref(ElRow), {
        gutter: 20
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modules.value, (item, index) => {
          return _openBlock(), _createBlock(_unref(ElCol), {
            key: index,
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_unref(ElCard), {
              class: "module-card"
            }, {
              header: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", _hoisted_2, _toDisplayString(item.title), 1)])]),
              default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("p", _hoisted_4, "模块ID " + _toDisplayString(item.moduleId), 1), _createElementVNode("p", _hoisted_5, "模块类型 " + _toDisplayString(item.moduleType), 1), _createElementVNode("p", _hoisted_6, "开通时间 " + _toDisplayString(item.openTime), 1)])]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      });
    };
  }
});